// extracted by mini-css-extract-plugin
module.exports = {"banner":"b3Ln_4","info":"_1i-P2R","title":"CkPr7w"};